import { useMemo } from 'react';
import API from '../../../../Utils/api';
import useAsync from '../../../../Hooks/useAsync';
import Card from '../../../../Components/Dashboard/Card';
import { CardEmpty, CardError, CardLoading } from '../../../../Components/Dashboard/CardState';
import { formatKm } from '../../../../Utils/format/pace';
import { lastFourWeeks } from './rangeLast4Weeks';
import HBarList from './HBarList';

const TITLE = 'Training zones';
const LABEL = {
    rec: 'Over distance (Rec)',
    end1: 'Basic aerobic (End1)',
    end2: 'Lactate threshold (End2)',
    end3: 'VO2 max (End3)',
    sp1: 'Lactate tolerance (SP1)',
    sp2: 'Produce lactate (SP2)',
    sp3: 'Max speed & power (SP3)'
};
// light to dark, as the mock orders the zones
const COLOR = ['var(--blue-200)', 'var(--blue-300)', 'var(--blue-500)', 'var(--blue-700)', 'var(--blue-800)', 'var(--blue-900)', '#050f2e'];

const TrainingZonesCard = ({ athleteId, now: nowProp }) => {
    const now = useMemo(() => nowProp || new Date(), [nowProp]);
    const { status, data, error, reload } = useAsync(
        () => API.getTrainingZonesStats(athleteId, lastFourWeeks(now)).then(res => res.data),
        [athleteId]
    );
    const total = (data || []).reduce((a, r) => a + r.distance, 0);

    let body;
    if (status === 'loading' && !data) body = <CardLoading label={TITLE} />;
    else if (status === 'error') body = <CardError label={TITLE} status={error?.response?.status} onRetry={reload} />;
    else if (!total) body = <CardEmpty>No training distance in the last 4 weeks.</CardEmpty>;
    else
        body = (
            <HBarList
                rows={data.map((r, i) => ({
                    key: r.zone,
                    label: LABEL[r.zone] || r.zone,
                    value: r.distance,
                    text: `${formatKm(r.distance)} km · ${r.percentage}%`,
                    color: COLOR[i]
                }))}
            />
        );

    return (
        <Card id="tz" module="athlete-zones" title={TITLE} sub="distance, last 4 weeks" busy={status === 'loading'}>
            {body}
        </Card>
    );
};

export default TrainingZonesCard;
